export default __webpack_public_path__ + "static/media/CommonInternetWhalingAttacks2.5c94c9fd.png";